import SignUpStepContainer from "./SignUpStepContainer";
import { CalendlyInlineEmbed } from "./CalendlyInlineEmbed";
import { FC, useEffect, useState } from "react";
import { ButtonIcon } from "../UI/Buttons";
import { REGISTRATION_STEPS } from "@/data";

const vo2CalendlyUrl = import.meta.env.VITE_CALENDLY_VO2MAX_URL;

const Vo2MaxRegistrationStep: FC<{
  onEventScheduled?: (data: unknown) => void;
  productSteps: REGISTRATION_STEPS[];
}> = ({ onEventScheduled, productSteps }) => (
  <SignUpStepContainer
    step={REGISTRATION_STEPS.VO2MAX_CALENDLY_REG}
    productSteps={productSteps}
    header="VO₂ max tyrimas"
    description={[
      "Pasirinkite Jums tinkamą laiką per žemiau esančią Calendly formą.",
    ]}
  >
    <CalendlyVo2Reservation onEventScheduled={onEventScheduled} />
  </SignUpStepContainer>
);

export default Vo2MaxRegistrationStep;

const CalendlyVo2Reservation: FC<{
  onEventScheduled?: (data: unknown) => void;
}> = ({ onEventScheduled }) => {
  const [eventData, setEventData] = useState<unknown>();

  useEffect(() => {
    if (!onEventScheduled) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://calendly.com") return;
      if (event.data.event && event.data.event === "calendly.event_scheduled") {
        setEventData(event.data);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onEventScheduled]);

  const base = vo2CalendlyUrl;
  const dataUrl = base.includes("?")
    ? `${base}&primary_color=2a1645`
    : `${base}?primary_color=2a1645`;

  return (
    <>
      <CalendlyInlineEmbed
        url={dataUrl}
        className="min-w-full md:min-w-[800px]"
        style={{ width: "100%", height: "700px" }}
      />
      {eventData && (
        <ButtonIcon
          className="mb-12 md:mb-16"
          icon="arrow-right"
          theme="light"
          label="Tęsti"
          onClick={() => onEventScheduled?.(eventData)}
        />
      )}
    </>
  );
};
